import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Player, TrackType } from 'fl-player-interface';
import { ResourceVm } from 'qp-ui-interface';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
import { LocalStorageKeys } from '../../shared/LocalStorageKeys';
import { getTextTrackList } from '../../shared/utils/PlaybackUtils';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';
import { trackByKey } from '../../shared/utils/trackBy';
export interface Track {
  type: TrackType;
  language: string;
  name: string;
  active: boolean;
}

@Component({
  selector: 'app-player-subtitles',
  templateUrl: './player-subtitles.component.html',
  styleUrls: ['./player-subtitles.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlayerSubtitlesComponent implements OnInit {
  @ViewChild('formatSize') formatText: ElementRef;
  @Output() closeDialog = new EventEmitter<void>();
  textTrackList: Track[] = [];
  selectedTextIndex: number;
  trackByLanguage = trackByKey<Track, 'language'>('language');

  constructor(
    private localStorage: LocalStorageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      currentResource: ResourceVm;
      player: Player;
    },
    private navService: NavigationLibraryService
  ) {}

  ngOnInit(): void {
    if (this.data.player) {
      this.textTrackList = getTextTrackList(this.data.player);
      const selectedTextIndex = this.textTrackList.findIndex(
        (textTrackLt) => textTrackLt.language === this.localStorage.getItem(LocalStorageKeys.SUBTITLES_LANGUAGE)
      );
      this.selectedTextIndex = selectedTextIndex >= 0 ? selectedTextIndex : 0;
      this.navService.focusContainer('subtitles-container', false, this.selectedTextIndex);
    }
  }

  selectTextTrack(textTrack: Track, index: number): void {
    if (!textTrack) {
      textTrack = this.textTrackList[0];
      this.selectedTextIndex = 0;
    } else {
      this.selectedTextIndex = index;
    }
    this.localStorage.setItem(LocalStorageKeys.SUBTITLES_LANGUAGE, textTrack.language);
    if (textTrack.language === 'off') {
      this.data.player.selectTrack();
      this.localStorage.setItem(LocalStorageKeys.SUBTITLES_ENABLED, 'false');
    } else {
      this.data.player.selectTrack(textTrack);
      this.localStorage.setItem(LocalStorageKeys.SUBTITLES_ENABLED, 'true');
    }
    this.textTrackList.forEach((textTrackLt) => (textTrackLt.active = textTrack.language === textTrackLt.language ? true : false));
  }

  /**
   * Handle mouse enter in div to magic remote
   *
   * @param event
   * @param index
   */
  mouseEnter(event: MouseEvent, index: number): void {
    this.navService.focusElement(event.target as HTMLElement, 0, index);
  }

  /**
   * Handle close button event
   */
  close(): void {
    this.closeDialog.emit();
  }
}
